import dayjs from "dayjs";
import React, { Fragment, useEffect, useState } from "react";
import { Alert } from "react-bootstrap";
import { TApiOrderDetails } from "../../api/endpoints/Order";
import EditOrderForm from "../../containers/Order/EditOrderForm";
import CostVersion from "./CostVersion";

interface Props {
  order: TApiOrderDetails;
  children: JSX.Element | null;
}

const isOrderCostCompatible = (order: TApiOrderDetails) => {
  return order.expired_code !== 'unsupported_costing_version';
}

const isOrderDataCompatible = (order: TApiOrderDetails) => {
  const isStartDateCompatible = order.start_date && dayjs(order.start_date).isAfter(new Date());

  return isStartDateCompatible;
}

const OrderSubmissionFormCompatibility = (props: Props) => {
  const { order, children } = props;
  const [costStageCompleted, setCostStageCompleted] = useState<boolean>(false);

  useEffect(() => {
    setCostStageCompleted(isOrderCostCompatible(order));
  }, [order]);

  const isDataCompatible = isOrderDataCompatible(order);
  const isOrderCompatible = isDataCompatible && costStageCompleted;

  if (isOrderCompatible) {
    return children;
  }

  if (!costStageCompleted) {
    return (
      <CostVersion
        order={order}
        onComplete={() => setCostStageCompleted(true)}
      />
    )
  }

  return (
    <Fragment>
      <Alert variant="warning" className="margin-bottom-md">
        It seems that this draft is out of date. We require some more information from you. Please update the
        information below.
      </Alert>

      <EditOrderForm order={order} />
    </Fragment>
  )
}

export default OrderSubmissionFormCompatibility;
